<div>
  Filter applied, some items in the data range are hidden.
  <a (click)="clearFilter()">Clear filters</a>
</div>
<button (click)="close()">
  <i class="xos-icon icon-close-white"></i>
</button>
